<template>

    <div class="container">
        <div class="row productscontainer">
            <div
                v-if="products.data.length === 0"
                class="text-center"
            >
                <p v-html="lang('products.overview.no-products')"></p>
            </div>
            <div
                v-for="product in products.data"
                class="col-6 col-md-4 col-lg-3"
            >
                <overview-item
                    :product="product"
                ></overview-item>
            </div>
        </div>

        <div
            v-if="products.meta && products.meta.last_page > 1"
            class="mt-5"
        >
            <pagination
                :meta="products.meta"
                :links="products.links"
            ></pagination>
        </div>
    </div>

</template>

<script>

import Layout from "../../../Shared/Layout";
import OverviewItem from "../../../components/Products/OverviewItem";
import Pagination from "../../../components/Pagination.vue";

export default {

    components: {
        OverviewItem,
        Pagination,
    },

    layout:Layout,

    metaInfo() {
        return {
            title: this.lang('products.overview.meta.title'),
            meta: [
                { name: 'description', content: this.lang('products.overview.meta.description', {'%shopname%': this.$page.props.name}) }
            ],
        }
    },

    mounted() {
        this.$GA4.dispatch('view_item_list');
    },

    name:'OpenProductsIndex',

    props: {
        products: {
            required:true,
        },
    },

}

</script>
